<template>
    <v-form ref="form">
        <v-row>
            <v-col>
                <v-text-field
                    :label="$t('name')"
                    outlined
                    dense
                    :value="name"
                    @input="$emit('update:name', $event)"
                    hide-details="auto"
                    :rules=[isRequired]>
                </v-text-field>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { isRequired } from './../../utils/validations';

export default {
    props: {
        name: String,
    },
    data() {
        return{}
    },
    methods: {
        isRequired,
        validate() {
            return this.$refs.form.validate();
        }
    },
    watch:{},
}
</script>

<style>

</style>